import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'

const DeleteAccountButton: React.FC = () => {
  const [isDeleting, setIsDeleting] = useState(false)
  const navigate = useNavigate()

  const handleDeleteAccount = async () => {
    // Première confirmation
    const firstConfirm = window.confirm(
      '⚠️ ATTENTION : Cette action est irréversible.\n\n' +
      'Ton compte sera définitivement supprimé et tes informations personnelles seront effacées.\n' +
      'Tes commandes et messages resteront présents mais de manière anonyme.\n\n' +
      'Es-tu sûr de vouloir continuer ?'
    )

    if (!firstConfirm) return

    // Deuxième confirmation : l'utilisateur doit taper "SUPPRIMER"
    const confirmation = window.prompt(
      'Pour confirmer la suppression de ton compte, tape exactement le mot : SUPPRIMER'
    )

    if (confirmation !== 'SUPPRIMER') {
      if (confirmation !== null) {
        alert('La confirmation n\'est pas exacte. Suppression annulée.')
      }
      return
    }

    try {
      setIsDeleting(true)

      // Récupérer la session pour obtenir le access_token
      const { data: { session }, error: sessionError } = await supabase.auth.getSession()

      if (sessionError || !session) {
        alert('Erreur : tu dois être connecté pour supprimer ton compte.')
        setIsDeleting(false)
        return
      }

      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL

      // Appeler l'Edge Function delete-account
      const response = await fetch(`${supabaseUrl}/functions/v1/delete-account`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'Erreur lors de la suppression du compte')
      }

      const data = await response.json()

      if (data.ok) {
        // Déconnexion puis redirection
        await supabase.auth.signOut({ scope: 'local' })
        alert('Ton compte a été supprimé avec succès.')
        navigate('/auth', { replace: true })
      } else {
        throw new Error('La suppression a échoué')
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du compte:', error)
      alert(`Erreur : ${error instanceof Error ? error.message : 'Impossible de supprimer le compte'}`)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <button
      className="btn btn-ghost"
      onClick={handleDeleteAccount}
      disabled={isDeleting}
      style={{
        color: '#64748b',
        border: 'none',
        marginTop: '1rem',
        fontSize: '.8rem',
        opacity: 0.6,
        textDecoration: 'underline',
        padding: '.25rem 0',
      }}
    >
      {isDeleting ? 'Suppression en cours…' : 'Supprimer mon compte'}
    </button>
  )
}

export default DeleteAccountButton
